module.exports = __webpack_public_path__ + "img/Rob.d273d382.png";